"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _jss = require("jss");
var _styles = require("@material-ui/styles");
var _animationStyle = _interopRequireDefault(require("./animationStyle"));
var _globalStyle = _interopRequireDefault(require("./globalStyle"));
var _theme = _interopRequireDefault(require("./theme"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*:: import { type ThemeType } from './ThemeTypes';

// Attach Global stylesheet, reset user-agent styles*/
// Attach Global stylesheet, reset user-agent styles
(0, _jss.create)(_objectSpread(_objectSpread({}, (0, _styles.jssPreset)()), {}, {
  insertionPoint: window.document.getElementById('global-css')
})).createStyleSheet(_globalStyle.default, {
  meta: 'Global'
}).attach();

// Attach Animation stylesheet, keyframe animations used by all components
(0, _jss.create)(_objectSpread(_objectSpread({}, (0, _styles.jssPreset)()), {}, {
  insertionPoint: window.document.getElementById('animation-css')
})).createStyleSheet(_animationStyle.default, {
  meta: 'Animation'
}).attach();
/*:: type Props = {
  theme: ThemeType
};*/
var ThemeProvider = function ThemeProvider(props /*: Props*/) {
  _react.default.useEffect(function () {
    window.document.documentElement.setAttribute('data-userAgent', navigator.userAgent);
    window.document.documentElement.setAttribute('data-platform', navigator.platform);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, props);
};
ThemeProvider.displayName = 'ThemeProvider';
ThemeProvider.defaultProps = {
  theme: _theme.default
};
var _default = exports.default = ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map